// 导航-->中英文
export const home = {
    'zhCN': {
        home: {
            announcementdetails: '公告详情',
            releaseTime: '发布时间',
            announcement: '通知公告',
            toDoList: '待办事项',
            goToTheOffice: '去待办',
            userStatistics: '用户情况统计',
            loginTimes: '登录次数',
            commonDocumentDownload: '常用文档下载'
        },
        homeSetting: {
            ddiContributionRateNotNull: 'DDI商业TMS贡献率不能为空',
            noticeDefaultNumber: '公告默认条数',
            noticeDefaultNumberNotNull: '公告默认条数不能为空',
            chooseDistributor: '选择流向商业',
            cancleOtherShipperSetting: '确认取消设置其他货主吗？',
            cancleSuccess: '取消成功。',
            cancle: '取消'
        }
    },
    'enUS': {
        home: {
            announcementdetails: 'Announcement details',
            releaseTime: 'Release time',
            announcement: 'Announcement',
            toDoList: 'To-do list',
            goToTheOffice: 'Go to the office',
            userStatistics: 'User statistics',
            loginTimes: 'Login times',
            commonDocumentDownload: 'Common Document Download'
        },
        homeSetting: {
            ddiContributionRateNotNull: 'DDI contribution rate can not be empty.',
            noticeDefaultNumber: 'Notice Default Number',
            noticeDefaultNumberNotNull: 'Notice default number can not be empty.',
            chooseDistributor: 'Choose Distributor',
            cancleOtherShipperSetting: 'Are you sure to cancel the establishment of other shippers?',
            cancleSuccess: 'Cancellation was successful.',
            cancle: 'Cancle'

        }
    }
}
export default home



// WEBPACK FOOTER //
// ./src/locale/modules/home.js